/** Описывает управляемый ленивый singleton для runtime-конфигурации. */
export interface Singleton<T extends object> {
  getInstance: () => T;
  setInstance: (value: T) => void;
  resetInstance: () => void;
}

/** Создаёт singleton с возможностью подмены и сброса в тестах. */
export const makeSingleton = <T extends object>(create: () => T): Singleton<T> => {
  let instance: T | null = null;

  /** Создаёт значение при первом обращении и сохраняет его. */
  const getInstance = (): T => {
    if (!instance) {
      instance = create();
    }

    return instance;
  };

  /** Заменяет значение singleton тестовым или runtime-экземпляром. */
  const setInstance = (value: T): void => {
    instance = value;
  };

  /** Сбрасывает значение singleton перед следующим сценарием. */
  const resetInstance = (): void => {
    instance = null;
  };

  return { getInstance, setInstance, resetInstance };
};
